import React from 'react';
import './StatusBadge.css';

export type StatusBadgeTone = 'success' | 'neutral' | 'warning' | 'danger' | 'info';

export type StatusBadgeProps = {
  label: string;
  tone?: StatusBadgeTone;
  /** Muestra punto indicador (default true) */
  showDot?: boolean;
  className?: string;
};

/**
 * Badge de estado genérico. El dominio decide label/tone; el componente solo presenta.
 */
const StatusBadge: React.FC<StatusBadgeProps> = ({
  label,
  tone = 'neutral',
  showDot = true,
  className = '',
}) => (
  <span className={`status-badge status-badge--${tone} ${className}`.trim()}>
    {showDot ? <span className="status-badge__dot" aria-hidden /> : null}
    {label}
  </span>
);

export default StatusBadge;
